// react
// components
import React from "react";
import { useSelector } from "react-redux";

import { Avatar } from "@performyard/py-components";

import { getUserID } from "../../../selectors/app";

import { employeeDetailsLinkWithFrom } from "../../../utils/employeeDetailsBreadcrumbs";

import Link from "../../Link";
import Typography from "../../Text";

type UserBlockProps = {
	id?: string;
	name?: string;
};

const UserBlock = ({ id, name }: UserBlockProps) => {
	const currentUserId = useSelector(getUserID);
	return (
		<div className="user-block" data-testid={`${name?.replace(/ /g, "-")}-user-block`}>
			<Avatar size={20} name={name || "User"} dangerouslySetClassName="user-image circle" id={id} />
			<div className="user-name" title={name}>
				<Link href={employeeDetailsLinkWithFrom(id, currentUserId)} forceHardReload={true}>
					<Typography weight="regular" size="paragraph-3" className="py-line-clamp-1">
						{name}
					</Typography>
				</Link>
			</div>
		</div>
	);
};

export default UserBlock;
